// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__zYu1Z","active":"Pagination_active__THnKb","cornerButton":"Pagination_cornerButton__GiXk0"};